import React, { FC } from 'react';

import cn from 'classnames';

import styles from './InfoTextBlock.module.scss';

type TInfoTextBlockProps = {
  children: React.ReactNode;
  classes?: {
    wrapper?: string;
    text?: string;
  };
};

const InfoTextBlock: FC<TInfoTextBlockProps> = ({ children, classes }): JSX.Element => {
  return (
    <div className={cn(styles.descriptionWrapper, { [classes?.wrapper ?? '']: !!classes?.wrapper })}>
      <p className={cn(styles.descriptionText, { [classes?.text ?? '']: !!classes?.text })}>{children}</p>
    </div>
  );
};

export default InfoTextBlock;
